import React, { useState } from "react";
import { Card, CardContent } from "./ui/card";
import { CheckCircle2, Cpu, Shield, Wifi, Wrench } from "lucide-react";

const TechShowcase = () => {
  const techStack = [
    {
      title: "Systèmes Photovoltaïques",
      icon: Cpu,
      features: [
        "Panneaux haute performance",
        "Installation professionnelle",
        "Monitoring en temps réel",
        "Garantie 25 ans",
      ],
      image:
        "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3NjEwNjg0NTB8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Climatisation Réversible",
      icon: Wrench,
      features: [
        "Technologie inverter",
        "Efficacité énergétique A+++",
        "Contrôle intelligent",
        "Maintenance incluse",
      ],
      image: "https://images.pexels.com/photos/2539462/pexels-photo-2539462.jpeg",
    },
    {
      title: "Solutions Énergétiques",
      icon: Shield,
      features: [
        "Contrats optimisés",
        "Tarifs compétitifs",
        "Gestion simplifiée",
        "Support 24/7",
      ],
      image:
        "https://images.unsplash.com/photo-1474631245212-32dc3c8310c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxlbmVyZ3l8ZW58MHx8fHwxNzYxMDY4NDY2fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Fibre Optique",
      icon: Wifi,
      features: [
        "Très haut débit",
        "Installation rapide",
        "Réseau sécurisé",
        "Prix fixe garanti",
      ],
      image:
        "https://images.unsplash.com/photo-1594915440248-1e419eba6611?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxmaWJlciUyMG9wdGljfGVufDB8fHx8MTc2MTA2ODQ3MXww&ixlib=rb-4.1.0&q=85",
    },
  ];

  return (
    <section id="technologie" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-sm font-bold text-blue-600 uppercase tracking-wider mb-4">
            L'AVENIR DE L'ÉNERGIE
          </h2>
          <p className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Notre gamme technologique</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-20">
          {techStack.map((tech, index) => {
            const Icon = tech.icon;
            return (
              <Card
                key={index}
                className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-blue-500 overflow-hidden"
              >
                <CardContent className="p-0">
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={tech.image}
                      alt={tech.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <div className="flex items-center space-x-3 mb-2">
                        <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
                          <Icon className="text-white" size={24} />
                        </div>
                        <h3 className="text-2xl font-bold text-white">{tech.title}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="p-6 space-y-3">
                    {tech.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center space-x-3">
                        <CheckCircle2 className="text-emerald-500 flex-shrink-0" size={20} />
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
          <div className="text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">40%+</p>
            <p className="text-gray-600">Gains moyens de capacité</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">5000+</p>
            <p className="text-gray-600">Installations réalisées</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">24/7</p>
            <p className="text-gray-600">Support client</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">50+</p>
            <p className="text-gray-600">Villes couvertes</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechShowcase;